export const initialState = () => {
    return {
        /*
         *  PAGES
         */
        currentPage: {
            slug: '',
            title: '',
            description: '',
            seo_title: '',
            seo_description: '',
            seo_ogimage: ''
        },

        pages: []
    }
}
